import { SVGProps } from 'react';

const ChartColumnIncreasing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13 17V9m5 8V5M3 3v16a2 2 0 0 0 2 2h16M8 17v-3"
    />
  </svg>
);
export default ChartColumnIncreasing;
